// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jqeH","right":"styles_right__2eVZt"};